<template>
    <div class="content-wrapper">
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <app-breadcrumb :page-title="'Inquiry By Center'" :directory="$t('report')" :icon="'grid'"/>
            </div>
            <div class="col-sm-12 col-md-6 breadcrumb-side-button">
                <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
                </div>
            </div>
            <div class="col-md-12">
                <div class="form-group row align-items-center">
                    <label for="inputs_semester" class="col-md-12" style="font-size: 16px;font-weight: 600;">
                        Semester
                    </label>
                    <app-input
                        id="inputs_semester"
                        class="col-sm-4"
                        v-model="input_semester"
						@input="setSemesterValue"
                        type="advance-search-select"
                        placeholder="Semester"
						:fetch-url="`report/get-semester`"
						list-value-field="nama"
                    />
                </div>
            </div>
            <div class="col-md-12">
                <app-overlay-loader v-if="preloader" class="h-100"/>
            </div>
             
            <div class="col-md-12" v-if="!preloader">
                <div class="row">
                    <div class="col-md-12"  style="margin-bottom: 19px;" v-for="(item, index) in rowData" :key="index">
                    <div class="center-name">{{ item.center.name }}</div>
                    <div class="card">
                        <div class="table-wrapper">
                            <table class="table-Report" :class="{ 'loading-opacity': preloader }">
                                
                                <template v-for="termItem in item.term">
                                    <tr>
                                        <th rowspan="2" class="lf-0" style="white-space:nowrap;">{{ termItem.term }}</th>
                                        
                                        <th v-for="(week, i) in padWeeks(getWeeks(termItem), getMaxWeekLength(item))"
                                            :key="'h'+i">

                                            <div v-if="week" class="header-weekly"
                                                v-html="formatRange(week.min, week.max)">
                                            </div>

                                            <div v-else class="header-weekly">
                                                &nbsp;
                                            </div>
                                        </th>
                                        <th rowspan="2">Total</th>
                                    </tr>
                                    <tr>
                                        <th v-for="(week, i) in padWeeks(getWeeks(termItem), getMaxWeekLength(item))"
                                            :key="'w'+i">

                                            {{ week ? week.week : '' }}
                                        </th>
                                    </tr>
                                    <tr>
                                        <td class="background-total-inquiry"></td>

                                        <td v-for="(week, i) in padWeeks(getWeeks(termItem), getMaxWeekLength(item))"
                                            :key="'d'+i" class="background-total-inquiry">

                                            {{ week ? week.total_inquiry : '' }}
                                        </td>

                                        <td>
                                            {{ termItem.total_by_term }}
                                        </td>
                                    </tr>
                                </template>
                                
                                <tr>

                                    <td :colspan="getMaxWeekLength(item) + 1" class="td-all-term">
                                        Total
                                    </td>

                                    <td class="td-all-term">
                                        {{ item.total_all_term }}
                                    </td>
                                </tr>
                            </table>
                        </div>
                        
                    </div>
                </div>
                </div>
            </div>
            
        </div>

    </div>
</template>

<script>
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import {urlGenerator} from "../../../../Helpers/AxiosHelper";
import { FormMixin } from "./FormMixin.js";

export default {
    extends: CoreLibrary,
    name: "InquiryByCenter",
    mixins: [FormMixin],
	data() {
		return {
            semesterId: null,
            rowData: {
            },
			preloader: true,
			semesterList : [],
            input_semester:{}
        }
    },
    mounted() {
        // this.loadData();
        // this.semester();
        this.initSemester();
    },
    methods: {
        getWeeks(termItem) {
            return termItem?.calendar?.[0] || [];
        },

        getMaxWeekLength(item) {
            let max = 0;

            item.term.forEach(t => {
                const len = this.getWeeks(t).length;
                if (len > max) max = len;
            });

            return max;
        },

        padWeeks(weeks, max) {
            const result = [...weeks];

            while (result.length < max) {
                result.push(null); 
            }

            return result;
        },
        async initSemester() {
            const resSemester = await axios.get(
                `/report/get-semester`
            );

            resSemester.data.data.forEach((item) => {
                this.semesterList.push({
                    id: item.id,
                    nama: item.nama,
                });
            });

            if (this.semesterList.length > 0) {
                this.semesterId = this.semesterList[0].id;
                this.input_semester = this.semesterList[0];
                this.loadData(this.semesterId);
            }
        },
        async loadData(semesterId = null) {
            try {
			    this.preloader= true;

                const res = await axios.get(
                    `/report/get-data-inquiry-by-center`,
                    {
                        params: {
                            semester: semesterId
                        }
                    }
                );

                this.rowData = Array.isArray(res.data) ? res.data : res.data || [];
                this.preloader= false;
            } catch (err) {
                this.rowData = {
                    header: [],
                    body: []
                };
                this.preloader= false;
            }
        },
		setSemesterValue(data) {
			this.semesterId = data.id;
            this.input_semester=data;
            this.loadData(this.semesterId);
		},
        formatDate(date) {
            const d = new Date(date);

            const day = String(d.getDate()).padStart(2, '0');

            const month = d.toLocaleDateString('en-GB', {
                month: 'short'
            });

            return `${day}-${month}`;
        },

        formatRange(min, max) {
            return `${this.formatDate(min)}-<br>${this.formatDate(max)}`;
        }
      
    },
}
</script>
<style scoped>
    .table-Report{
        border: 1px solid black;
    }
    .table-Report th{
        background: #007bff;
        color: white;
        padding: 10px;
        text-align: center;
        font-size: 12px;
        border: 1px solid black;
    }
    .table-Report td{
        background: white;
        font-size: 12px;
        color: black;
        padding: 10px;
        text-align: center;
        border: 1px solid black;
    }
    .header-weekly{
        white-space: nowrap;
        
    }
    .table-wrapper {
        border: 1px solid black;
        width: 100%;
        overflow-x: auto;
    }
    .table-Report {
        width: max-content; 
        min-width: 100%;  
        border-collapse: collapse;
    }
    .lf-0{
        position: sticky;
        left: 0;
    }
    .center-name{
        font-size: 17px;
        font-weight: 600;
    }
    .background-total-inquiry{
        background: #ffe3c5 !important;
    }
    .td-all-term{
        padding: 5px;
        font-weight: 600;
        font-size: 14px;
    }
</style>
